import { getProfileFilter } from '../../../../api/profiles';
import FilterContent from '../components/FilterContent';

export default function (page) {
  return getProfileFilter().then(({ data }) => {
    const filtersLinks = [
      {
        id: 0,
        title: 'Kids Profile',
        name: 'kids_approved',
        checked: data.kids_approved,
      },
      {
        id: 1,
        title: 'Remove Kids Content',
        name: 'parents_approved',
        checked: data.parents_approved,
      },
      {
        id: 2,
        title: 'Sunday Approved - All Week',
        name: 'sunday_approved',
        checked: data.sunday_approved,
      },
      {
        id: 3,
        title: 'Sunday Approved - Sundays Only',
        name: 'sunday_approved_sundays_only',
        checked: data.sunday_approved_sundays_only,
      },
      {
        id: 4,
        title: 'Remove PG-13',
        name: 'remove_pg13',
        checked: data.remove_pg13,
      },
      // {
      //   id: 5,
      //   title: 'Remove LDS Titles',
      //   name: 'remove_lds_titles',
      //   checked: data.remove_lds_titles,
      // },
    ];
    const items = filtersLinks.map((filter, index) => ({
      collision: true,
      index,
      type: FilterContent,
      filterLink: filter,
    }));
    page._FilterContent.items = items;
  });
}
